<template>
  <v-list class="permission-list">
    <template v-for="(permiso, index) in allPermisos" :key="index">
      <!-- Grupo con hijos -->
      <v-list-group
        :class="['permission-group', { 'permission-nested': permiso.permisoPadreId !== null }]"
        v-if="permiso.permisoHijos.length > 0"
      >
        <template v-slot:activator="{ props }">
          <v-list-item
            v-bind="props"
            class="permission-item permission-parent"
            :class="{ 'permission-disabled': disableSeletion }"
          >
            <template v-slot:prepend>
              <v-checkbox-btn
                :model-value="permiso.permisoIsFromUserGroup"
                @update:model-value="emitSeleccionarPermiso(permiso)"
                @click.stop
                :disabled="disableSeletion"
                class="permission-checkbox"
              />
            </template>

            <v-list-item-title class="permission-title">
              {{ permiso.permisoNombre }}
            </v-list-item-title>

            <template v-slot:append>
              <div class="permission-actions">
                <v-tooltip text="Editar permiso" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon
                      variant="text"
                      size="small"
                      class="permission-action-btn"
                      @click.stop="emitOpenEditDialog(permiso)"
                    >
                      <v-icon size="18">{{ editIcon }}</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
                
                <v-tooltip text="Eliminar permiso" location="top">
                  <template v-slot:activator="{ props }">
                    <v-btn
                      v-bind="props"
                      icon
                      variant="text"
                      size="small"
                      class="permission-action-btn permission-delete-btn"
                      @click.stop="emitOpenDeleteDialog(permiso.permisoId, permiso.permisoNombre)"
                    >
                      <v-icon size="18">{{ deleteIcon }}</v-icon>
                    </v-btn>
                  </template>
                </v-tooltip>
              </div>
            </template>
          </v-list-item>
        </template>

        <div class="permission-children">
          <PermisoList
            v-if="permiso && permiso.permisoHijos"
            :allPermisos="permiso.permisoHijos"
            :disableCheck="disableSeletion"
            @emitSeleccionarPermiso="emitSeleccionarPermiso"
            @emitOpenEditDialog="emitOpenEditDialog"
            @emitOpenDeleteDialog="emitOpenDeleteDialog"
          />
        </div>
      </v-list-group>

      <!-- Permiso sin hijos -->
      <v-list-item
        v-else
        class="permission-item permission-leaf"
        :class="{ 
          'permission-disabled': disableSeletion,
          'permission-nested': permiso.permisoPadreId !== null 
        }"
      >
        <template v-slot:prepend>
          <v-checkbox-btn
            :model-value="permiso.permisoIsFromUserGroup"
            @update:model-value="emitSeleccionarPermiso(permiso)"
            :disabled="disableSeletion"
            class="permission-checkbox"
          />
        </template>

        <v-list-item-title class="permission-title">
          {{ permiso.permisoNombre }}
        </v-list-item-title>

        <template v-slot:append>
          <div class="permission-actions">
            <v-tooltip text="Editar permiso" location="top">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  class="permission-action-btn"
                  @click="emitOpenEditDialog(permiso)"
                >
                  <v-icon size="18">{{ editIcon }}</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            
            <v-tooltip text="Eliminar permiso" location="top">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon
                  variant="text"
                  size="small"
                  class="permission-action-btn permission-delete-btn"
                  @click="emitOpenDeleteDialog(permiso.permisoId, permiso.permisoNombre)"
                >
                  <v-icon size="18">{{ deleteIcon }}</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </div>
        </template>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import enums from "@/utils/enums/index";
import { mapGetters } from "vuex";
export default {
  props: {
    allPermisos: {
      type: Object,
      required: false,
      default: () => {},
    },
    isLoadingItems: {
      type: Boolean,
      default: false,
    },
    disableCheck: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    "emitSeleccionarPermiso",
    "emitOpenEditDialog",
    "emitOpenDeleteDialog",
  ],
  data() {
    return {
      editIcon: enums.icons.EDIT_ICON,
      deleteIcon: enums.icons.DELETE_ICON,
      disableSeletion: false,
    };
  },
  watch: {
    disableCheck(val) {
      this.disableSeletion = val;
    },
    isLoadingItems(val) {
      if (val) {
        this.$store.dispatch("user/changeAppLoading", {
          status: true,
          text: "",
        });
      } else {
        this.$store.dispatch("user/changeAppLoading", {
          status: false,
          text: "",
        });
      }
    },
  },
  computed: {
    ...mapGetters({ isMobile: "menu/isMobile" }),
  },
  methods: {
    emitOpenEditDialog(permiso) {
      this.$emit("emitOpenEditDialog", permiso);
    },
    emitOpenDeleteDialog(permisoId, permisoNombre) {
      this.$emit("emitOpenDeleteDialog", permisoId, permisoNombre);
    },
    emitSeleccionarPermiso(permiso) {
      this.$emit("emitSeleccionarPermiso", permiso);
    },
  },
};
</script>
<style scoped>
/* Lista principal de permisos */
.permission-list {
  padding: 8px;
}

/* Items de permisos */
.permission-item {
  min-height: 48px;
  padding: 8px 12px;
  margin-bottom: 4px;
  transition: background-color 0.2s ease;
  border-radius: 4px;
}

.permission-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Permisos padre (con hijos) */
.permission-parent {
  background-color: rgba(0, 0, 0, 0.02);
  border-left: 3px solid #ddd;
}

/* Permisos hoja (sin hijos) */
.permission-leaf {
  background-color: transparent;
}

/* Permisos anidados */
.permission-nested {
  margin-left: 24px;
}

/* Grupos de permisos */
.permission-group {
  margin-bottom: 8px;
}

/* Contenedor de hijos */
.permission-children {
  margin-top: 4px;
  padding-left: 12px;
  border-left: 1px solid #eee;
}

/* Checkbox */
.permission-checkbox {
  margin-right: 12px;
}

/* Título del permiso */
.permission-title {
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.87);
  flex-grow: 1;
}

.permission-parent .permission-title {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
}

/* Acciones */
.permission-actions {
  display: flex;
  gap: 4px;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.permission-item:hover .permission-actions {
  opacity: 1;
}

.permission-action-btn {
  width: 32px;
  height: 32px;
  min-width: 32px;
}

.permission-action-btn:hover {
  background-color: rgba(0, 0, 0, 0.08);
  color: rgba(0, 0, 0, 0.8);
}

.permission-delete-btn:hover {
  background-color: rgba(244, 67, 54, 0.08);
  color: rgb(244, 67, 54);
}

/* Estados deshabilitado */
.permission-disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* Responsive - Mobile */
@media (max-width: 600px) {
  .permission-item {
    padding: 6px 8px;
    min-height: 44px;
  }
  
  .permission-nested {
    margin-left: 16px;
  }
  
  .permission-children {
    padding-left: 8px;
  }
  
  .permission-title {
    font-size: 13px;
  }
  
  .permission-action-btn {
    width: 28px;
    height: 28px;
    min-width: 28px;
  }
}
</style>
